import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const POLL_MS = 2000;
const MAX_WAIT_MS = 240_000;

const sleep = (ms, signal) => new Promise((resolve, reject) => {
  const t = setTimeout(resolve, ms);
  signal?.addEventListener("abort", () => { clearTimeout(t); reject(new DOMException("Aborted", "AbortError")); }, { once: true });
});

/**
 * Run the write → review → improve pipeline as a background job and poll it.
 * `onUpdate(job)` fires on every poll; `job.status` is writing | reviewing | done | error.
 * Resolves with the finished job ({ lyrics, draft, review, model_label }).
 */
export async function runLyricsJob(payload, { signal, onUpdate } = {}) {
  const { data: started } = await axios.post(`${API}/lyrics/generate/start`, payload, { signal, timeout: 30_000 });
  const startedAt = Date.now();
  let lastStatus = null;
  while (Date.now() - startedAt < MAX_WAIT_MS) {
    await sleep(POLL_MS, signal);
    const { data: job } = await axios.get(`${API}/lyrics/generate/jobs/${started.job_id}`, { signal, timeout: 15_000 });
    if (job.status !== lastStatus || job.status === "done") {
      lastStatus = job.status;
      onUpdate?.(job);
    }
    if (job.status === "done") return job;
    if (job.status === "error") {
      const err = new Error(job.error || "Lyrics generation failed");
      err.jobError = true;
      throw err;
    }
  }
  throw new Error("Lyrics generation timed out — please try again.");
}
